// extracted by mini-css-extract-plugin
export default {"image":"SingleSelect_image__vtz8e","imageImg":"SingleSelect_imageImg__Sd6L-","imagePh":"SingleSelect_imagePh__7tgma"};